var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"subject-card"},[_c('router-link',{attrs:{"to":("/subjectDetail/" + (_vm.item.id) + "/home")}},[_c('img',{attrs:{"src":_vm._f("imageUrl")(_vm.item.thumb,'', 320,320),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86b0c67e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/peopleCenter/SubjectCard.vue
// module id = null
// module chunks = 